import type { ButtonHTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  children: ReactNode;
}

export function Button({ variant = "primary", className, children, ...rest }: ButtonProps) {
  const base = "inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50";
  const styles =
    variant === "primary"
      ? "text-white"
      : variant === "secondary"
      ? "border"
      : "";
  const colorVars =
    variant === "primary"
      ? ({ background: "var(--color-primary)", color: "var(--color-primary-fg)" } as const)
      : variant === "secondary"
      ? ({
          background: "var(--color-card)",
          borderColor: "var(--color-border)",
          color: "var(--color-fg)",
        } as const)
      : ({ color: "var(--color-fg)" } as const);
  return (
    <button {...rest} className={twMerge(base, styles, className)} style={{ ...colorVars, ...rest.style }}>
      {children}
    </button>
  );
}
